import React from 'react'
import withIcon from '@/components/withIcon'

function IconButterfly({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M14 20H7.41427C3.87177 20 1 17.1282 1 13.5857V4C8.1797 4 14 9.82029 14 17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M9 20C6.23858 20 4 22.2386 4 25C4 27.7614 6.23857 30 9 30C11.7614 30 14 27.7614 14 25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M18 20H24.5857C28.1282 20 31 17.1282 31 13.5857V4C23.8203 4 18 9.82029 18 17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M23 20C25.7614 20 28 22.2386 28 25C28 27.7614 25.7614 30 23 30C20.2386 30 18 27.7614 18 25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M14.4884 7.40857C14.4046 5.05281 12.9375 2.14583 11 1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M17.4491 7.40857C17.5329 5.05281 19 2.14583 20.9375 1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M18 12.2344V27.9995C18 29.1041 17.1046 29.9995 16 29.9995C14.8954 29.9995 14 29.1041 14 27.9995V12.2349"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M16 13C17.6569 13 19 11.6569 19 10C19 8.34315 17.6569 7 16 7C14.3431 7 13 8.34315 13 10C13 11.6569 14.3431 13 16 13Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  )
}

export default withIcon(IconButterfly)
